export default "__VITE_ASSET__DyaM_oHk__"